import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';

import waysFirstIcon from 'src/public/img/ways-1.svg';
import waysSecondIcon from 'src/public/img/ways-2.svg';

export const WaysToFitTogetherStep = withTranslation('cbt')(({ t }: WithTranslation) => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>{t('week-8.ways-to-fit-together.title')}</S.StepHeading>
                <S.StepDescription small>
                    {t('week-8.ways-to-fit-together.description')}
                </S.StepDescription>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn md={12}>
                <S.StepIcon style={{ height: '43.75rem' }} iconUrl={waysFirstIcon} />
            </S.ContentColumn>
            <S.ContentColumn md={12}>
                <S.StepIcon style={{ height: '35rem' }} iconUrl={waysSecondIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
));
